import EventEmitter from 'events';

export default class UartChannel extends EventEmitter {
  constructor(name, sendCallback) {
    super();

    this.name = name;
    this.sendCallback = sendCallback;
  }

  receiveData(/*data*/) {
    // nop
  }

  send(txData) {
    this.sendCallback(txData);
  }
}
